export const textInputStyle = {
  width: "100%",
  height: 36,
  padding: "0 12px",
  border: "1px solid var(--qv-border-strong, #d0d4dc)",
  borderRadius: 8,
  fontSize: 13,
  color: "var(--qv-text, #0f1115)",
  fontFamily: "inherit",
  outline: "none",
  boxSizing: "border-box",
};

export const btnPrimary = {
  height: 36,
  padding: "0 16px",
  borderRadius: 8,
  background: "var(--qv-brand)",
  color: "var(--qv-brand-on, #fff)",
  border: "none",
  fontSize: 13,
  fontWeight: 500,
  fontFamily: "CircularMedium",
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
};

export const btnGhost = {
  height: 36,
  padding: "0 16px",
  borderRadius: 8,
  background: "var(--qv-surface, #fff)",
  color: "var(--qv-text-secondary, #3d434f)",
  border: "1px solid var(--qv-border-strong, #d0d4dc)",
  fontSize: 13,
  fontWeight: 500,
  fontFamily: "CircularMedium",
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
};

export const btnPrimaryDisabled = {
  ...btnPrimary,
  fontFamily: "CircularMedium",
  fontWeight: 500,
  background: "var(--qv-brand-disabled, #bccffc)",
  cursor: "not-allowed",
};

export const btnGhostDisabled = {
  ...btnGhost,
  fontFamily: "CircularMedium",
  fontWeight: 500,
  opacity: 0.55,
  cursor: "not-allowed",
};

export const btnIconGhost = {
  ...btnGhost,
  width: 38,
  minWidth: 38,
  padding: 0,
  justifyContent: "center",
};

export const btnIconPrimary = {
  ...btnPrimary,
  width: 38,
  minWidth: 38,
  padding: 0,
  justifyContent: "center",
};

export const modeBtnStyle = {
  width: 30,
  height: 32,
  padding: 0,
  border: "none",
  cursor: "pointer",
  fontSize: 13,
  fontWeight: 500,
  fontFamily: "inherit",
};
